export default "__VITE_ASSET__dQFT1dtr__"